module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lost-reason-form",
    class: {
      'width-flow': _vm.send_to_new_flow
    }
  }, [_c('div', {
    staticClass: "lost-reason-form_header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.contact.full_name))]), _c('br'), _vm._v(_vm._s(_vm.contact.business.name))]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "flow-form__lost-selects"
  }, [_c('form', {
    staticClass: "row"
  }, [(_vm.status == 'connected') ? _c('div', {
    staticClass: "div col-md",
    class: {
      'col-md-12': !_vm.send_to_new_flow, 'col-md-5': _vm.send_to_new_flow
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new_stage')
    }
  }, [_c('label', [_vm._v("Selecione o novo estágio")]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "data-vv-name": "new_stage",
      "options": _vm.next_valid_stages
    },
    model: {
      value: (_vm.new_stage),
      callback: function($$v) {
        _vm.new_stage = $$v
      },
      expression: "new_stage"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_stage')),
      expression: "errors.has('new_stage')"
    }],
    key: "new_stage",
    staticClass: "help-block"
  }, [_vm._v("Favor selecionar o estágio")])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentário:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])]) : _vm._e(), (_vm.status == false || _vm.status == 'lost' || _vm.status == 'blocklisted') ? _c('div', {
    staticClass: "div col-md",
    class: {
      'col-md-12': !_vm.send_to_new_flow, 'col-md-5': _vm.send_to_new_flow
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('lost_reason_unit')
    }
  }, [_c('label', [_vm._v("Motivo de Perda")]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    class: {
      'cursor-not-allowed': _vm.disable_lost_reason_selection
    },
    attrs: {
      "disabled": _vm.disable_lost_reason_selection,
      "data-vv-name": "lost_reason_unit",
      "options": _vm.lostReasonOptions()
    },
    model: {
      value: (_vm.lost_reason_id),
      callback: function($$v) {
        _vm.lost_reason_id = $$v
      },
      expression: "lost_reason_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lost_reason_unit')),
      expression: "errors.has('lost_reason_unit')"
    }],
    key: "lost_reason_unit",
    staticClass: "help-block"
  }, [_vm._v("Favor selecionar o motivo de perda")])])], 1), (_vm.showCheckStatus) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Deseja atribuir status abaixo:")]), _c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item clickable-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBlocklist),
      expression: "checkBlocklist"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBlocklist"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBlocklist) ? _vm._i(_vm.checkBlocklist, null) > -1 : (_vm.checkBlocklist)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkBlocklist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBlocklist = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBlocklist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBlocklist = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "checkBlocklist"
    }
  }, [_vm._v("Blocklist")])])]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentário:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lost_reason_comment),
      expression: "lost_reason_comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lost_reason_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lost_reason_comment = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "toggler-inline",
    class: {
      'cursor-not-allowed': _vm.disable_lost_reason_selection
    },
    on: {
      "click": function($event) {
        return _vm.toggleType()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.send_to_new_flow
    }
  }), _c('label', [_vm._v("Enviar para novo fluxo?")])])])]) : _vm._e(), (_vm.send_to_new_flow) ? _c('div', {
    staticClass: "line-vertical"
  }) : _vm._e(), (_vm.send_to_new_flow) ? _c('div', {
    staticClass: "div col-md col-md-7"
  }, [_c('div', {
    staticClass: "form-group contact-list-item-flow autocomplete-flow",
    class: {
      'has-error': !_vm.flow && _vm.send_to_new_flow, 'has-warning': _vm.flow == _vm.contact.flow.id && _vm.contact.flow.id
    }
  }, [_c('label', [_vm._v("Buscar por nome do fluxo")]), _c('flows', {
    staticClass: "field",
    attrs: {
      "user_id": _vm.selected_user
    },
    on: {
      "flow-selected": _vm.selectFlow
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flow && _vm.send_to_new_flow && _vm.tried_to_save),
      expression: "!flow && send_to_new_flow && tried_to_save"
    }],
    key: "flow_error",
    staticClass: "help-block"
  }, [_vm._v("Favor selecionar o novo fluxo")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flow == _vm.contact.flow.id && _vm.contact.flow.id),
      expression: "flow == contact.flow.id && contact.flow.id"
    }],
    key: "flow_warning",
    staticClass: "help-block"
  }, [_vm._v("O contato já passou por este fluxo e será reiniciado.")])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Selecione um período para reativação"), _c('div', _vm._l((_vm.reactivation_period_options), function(period) {
    return _c('span', [_c('button', {
      staticClass: "button-reactivation-period",
      class: {
        'selected': period.days == _vm.reactivation_period
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setReactivationPeriod(period.days)
        }
      }
    }, [_vm._v(_vm._s(period.label))])])
  }), 0)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Customizada:")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 no-padding"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ("##/##/####"),
      expression: "\"##/##/####\""
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'),
      expression: "'required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.due_on_date),
      expression: "due_on_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "due_on_date",
      "placeholder": "DD/MM/AAAA"
    },
    domProps: {
      "value": (_vm.due_on_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.due_on_date = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "col-md-9 calendar-right-align"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "disabled": {
        to: _vm.yesterday
      },
      "language": "pt-br"
    },
    model: {
      value: (_vm.due_on_date_custom),
      callback: function($$v) {
        _vm.due_on_date_custom = $$v
      },
      expression: "due_on_date_custom"
    }
  })], 1)])]), (_vm.status !== 'connected') ? _c('div', {
    staticClass: "form-group new-stage"
  }, [_c('label', [_vm._v("Em qual estágio esse contato deve ser reativado?")]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "options": _vm.next_valid_stages,
      "selected": _vm.new_stage
    },
    model: {
      value: (_vm.new_stage),
      callback: function($$v) {
        _vm.new_stage = $$v
      },
      expression: "new_stage"
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _c('hr'), _c('div', {
    staticClass: "lost-reason-form_footer"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit("close-lost-reason-modal")
      }
    }
  }, [_vm._v("Cancelar")]), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc10fb5c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/modals/lost_reason_modal.vue
// module id = 1208
// module chunks = 1